var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"c-telemetry-table__sizing-tr"},[_c('td',[_vm._v("SIZING ROW")])])}]

export { render, staticRenderFns }